import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-package",
  "use": "icon-package-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-package\"><path d=\"M1 3.808V15h14V3.808h-4v6.788l-3-1.5-3 1.5V3.808H1ZM0 16V2.915L2.416 0h11.15L16 2.954V16H0ZM1.38 2.808H14.6L13.077 1H2.904L1.38 2.808Zm4.62 1V8.96l2-1 2 1V3.808H6Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol